import Seo from "@/components/Seo";
import Hero from "@/components/sections/Hero";
import TrustStatement from "@/components/sections/TrustStatement";
import ServicesOverview from "@/components/sections/ServicesOverview";
import BookingPlatforms from "@/components/sections/BookingPlatforms";
import WhyUs from "@/components/sections/WhyUs";
import ProcessSection from "@/components/sections/ProcessSection";
import Showcase from "@/components/sections/Showcase";
import Testimonials from "@/components/sections/Testimonials";
import FaqSection from "@/components/sections/FaqSection";
import AssessmentBanner from "@/components/sections/AssessmentBanner";
import CTASection from "@/components/CTASection";
import { SectionHeading } from "@/components/SectionHeading";
import PackagesGrid, { PackagesNote } from "@/components/PackagesGrid";

export default function Home() {
  return (
    <>
      <Seo
        title="HM Services | Hospitality Consultancy & Hotel Digital Growth"
        description="HM Services helps hotels, guest houses, resorts, villas and property owners improve their online presence, optimize booking platforms and grow their hospitality business."
        path="/"
      />
      <Hero />
      <TrustStatement />
      <ServicesOverview />
      <BookingPlatforms />
      <WhyUs />
      <ProcessSection />

      <section className="bg-mist py-24 lg:py-32" data-testid="packages-preview">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <SectionHeading
            eyebrow="Packages"
            title="Choose a Package That Fits Your Property"
            subtitle="Flexible packages with custom pricing, built around your property's size, platforms and goals."
          />
          <div className="mt-16">
            <PackagesGrid />
            <PackagesNote />
          </div>
        </div>
      </section>

      <AssessmentBanner />
      <Showcase />
      <Testimonials />
      <FaqSection />
      <CTASection />
    </>
  );
}
